/**
 * Whether the Roster screen is reachable (FE-109).
 *
 * The screen runs on mock data until the real adapter lands (plan step 9), and mock data on a
 * screen real users can reach is invented data (NS-4). So it is OFF against the production API
 * unless someone turns it on deliberately with `REACT_APP_FEATURE_ROSTER=true`, and on everywhere
 * else — local development and sandbox, which both point at the sandbox API.
 *
 * Environment is read from the API URL, the same signal the support top nav uses to tell sandbox
 * from production. The `.env.*` file names are not a reliable signal: `build:prod` sets
 * `REACT_APP_ENV` without exporting it, so the bundle never sees it.
 */
export interface RosterFeatureEnv {
    REACT_APP_FEATURE_ROSTER?: string;
    REACT_APP_API_URL?: string;
}

export function isRosterFeatureEnabled(env: RosterFeatureEnv): boolean {
    const flag = (env.REACT_APP_FEATURE_ROSTER || '').trim().toLowerCase();
    if (flag === 'true') {
        return true;
    }
    if (flag === 'false') {
        return false;
    }
    return /sandbox/.test(env.REACT_APP_API_URL || '');
}
